/**
 * Who may disable / enable whom (REQ-005, FE-5-6)
 * Location: frontend/src/utils/userStatusRules.js
 *
 * Mirrors the role rules of PATCH /admin/users/{email}/status
 * (CONTRACTS.md → "REQ-005 Phase E — Disable / enable a user"), which are
 * identical to delete: a super admin may act on anyone except themselves; a
 * tenant admin only on non-admin users in their own tenant; nobody else.
 *
 * This only decides what the UI offers. The backend enforces the same rules
 * (400 self, 403 role) and stays the authority.
 */

const ADMIN_ROLES = ['super_admin', 'tenant_admin'];

/**
 * @param {Object|null} actor - the signed-in user ({ email, role, tenant_id })
 * @param {Object|null} target - a row from GET /admin/users
 * @returns {boolean} true if the UI should offer Disable / Enable on this row
 */
export const canChangeUserStatus = (actor, target) => {
  if (!actor || !target) return false;
  if (actor.email && actor.email === target.email) return false;

  if (actor.role === 'super_admin') return true;

  if (actor.role === 'tenant_admin') {
    return Boolean(actor.tenant_id)
      && target.tenant_id === actor.tenant_id
      && !ADMIN_ROLES.includes(target.role);
  }

  return false;
};

/**
 * `disabled` is additive in GET /admin/users and defaults to false if absent.
 *
 * @param {Object} user - a row from GET /admin/users
 * @returns {boolean}
 */
export const isUserDisabled = (user) => user?.disabled === true;
